import { BUBBLE, ifyouApi } from 'apis/config';
import ErrorMessage from 'apis/ErrorMessage';

/// 말풍선 세트 리스트
export const bubbleSetApi = {
  read: () =>
    ifyouApi
      .get(`${BUBBLE}`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  register: (inputData) =>
    ifyouApi
      .post(`${BUBBLE}/register-bubble-set`, {
        set_name: inputData.set_name,
        remark: inputData.remark,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  update: (id, rows) =>
    ifyouApi
      .post(`${BUBBLE}/${id}/master-update`, {
        set_name: rows?.set_name,
        remark: rows?.remark,
        normal_font_size: Number(rows?.normal_font_size),
        big_font_size: Number(rows?.big_font_size),
        line_space: Number(rows?.line_space),
        tag_color_affect: rows?.tag_color_affect,
        tag_align_type: rows?.tag_align_type,
        tag_textarea_left: Number(rows?.tag_textarea_left),
        tag_textarea_right: Number(rows?.tag_textarea_right),
        tag_textarea_top: Number(rows?.tag_textarea_top),
        tag_textarea_bottom: Number(rows?.tag_textarea_bottom),
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  delete: (id) =>
    ifyouApi
      .post(`${BUBBLE}/${id}/master-delete`)
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detailRead: (id, variation) =>
    ifyouApi
      .post(`${BUBBLE}/${id}`, {
        variation: variation,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
  detailUpdate: (id, rows) =>
    ifyouApi
      .post(`${BUBBLE}/${id}/detail-update`, {
        rows: rows,
      })
      .then((res) => res.data)
      .catch((error) => {
        if (error.response) {
          ErrorMessage(error.response.status, error.response.data);
        }
      }),
};
